import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {ApiService} from "../../../../shared/services/api/api.service";
import {IMenuGroup} from "../models/menu-group";
import {IMenu} from "../models/menu";

@Injectable({
  providedIn: 'root'
})
export class MenuGroupService {

  constructor(private readonly apiService: ApiService) {
  }

  getList() {
    return this.apiService.get<any>('menuGroup')
  }

  getMenuList(menuGroupId: number): Observable<IMenu[]> {

    return this.apiService.get<any>(`menuGroup/${menuGroupId}/menus`)
  }

  create(menuGroup: IMenuGroup): Observable<IMenuGroup> {
    return this.apiService.post<IMenuGroup>('menuGroup/create', menuGroup)
  }

  update(menuGroup: IMenuGroup): Observable<IMenuGroup> {
    return this.apiService.patch<IMenuGroup>('menuGroup/update', menuGroup);
  }

  delete(menuGroupId: string,): Observable<IMenuGroup> {
    return this.apiService.delete<IMenuGroup>(`menuGroup/delete/${menuGroupId}`);
  }
}
